import { Component, OnInit, ViewChild, Output, EventEmitter, HostListener } from '@angular/core';
import { ModalComponent } from '../../../core/shared/modal/modal.component';
import { NgForm } from '@angular/forms';
import { RoleDetailsRest } from '../role-details/role-details.rest';
import { ObjectToSelect } from '../../../core/shared/objectToSelect.model';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';

@Component({
  selector: 'app-user-selection',
  templateUrl: './user-selection.component.html'
})
export class UserSelectionComponent implements OnInit, HasPermissions {
  permissions: Permissions;
  setPermissions(claimType: string): void {
    this.permissions = this.permissionService.getUserPermissions(claimType);
  }

  public users: ObjectToSelect[];
  public user: ObjectToSelect;
  public roleName: string;
  private currentUserRoleName: string;
  private isSaving = false;

  @ViewChild('userSelectionForm') userSelectionForm: NgForm;
  @ViewChild(ModalComponent) public modal: ModalComponent;
  @Output() onSuccess: EventEmitter<any> = new EventEmitter();

  constructor(private rest: RoleDetailsRest,
              private permissionService: PermissionsService) {
  }

  @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.modal.modalRoot.isShown === true && this.userSelectionForm.valid) {
      this.confirm();
      event.preventDefault();
    }
  }

  ngOnInit() {
    this.setPermissions("Role");
    this.modal.title = 'Dodaj użytkownika do roli';
    this.user = new ObjectToSelect();
  }

  public selectUser(users: ObjectToSelect[]) {
    this.users = users;
    this.modal.openWithCustomSize({ height: '25vh' });
  }

  public confirm() {
    if (this.isSaving) {
      return;
    }
    const action = this.rest.checkUserCurrentRole;
    action.call(this.rest, this.user.guid).subscribe((result: string) => {

      this.currentUserRoleName = result;
      let message = '';

      if (this.currentUserRoleName != '') {
        message = `Użytkownik jest przypisany do roli ${this.currentUserRoleName}. Czy na pewno zmienić jego rolę na ${this.roleName}?`;
      }
      else {
        message = `Czy na pewno przypisać użytkownika do roli ${this.roleName}?`;
      }

      sweetAlert(message, {
        buttons: {
          yes: {
            text: "Tak",
            value: "yes"
          },
          no: {
            text: "Nie",
            value: "no",
          }
        }
      })
        .then((value) => {
          switch (value) {
            case "yes":
              this.assignUserToRole();
              break;
          }
        });
    });
  }

  public closeModal() {
    this.modal.close();
  }

  private assignUserToRole() {
    this.isSaving = true;
    const action = this.rest.assignUserToRole;
    let emmitData = { isSuccess: true };
    action.call(this.rest, this.roleName, this.user.guid).subscribe(() => {
      this.isSaving = false;
      this.modal.close();
      this.onSuccess.emit(emmitData);
    });
  }
}